<template>
	<div class="container px-0" id="FeelingsLog" style="max-width: 730px;">
		<div class="page-header gold mt-4 mb-2">

      <back-btn to="/dashboard"></back-btn>

      <h3 class="mb-0">
				Reflections<small v-if="$store.state.profile_active">: {{ $store.state.profile_active.user_name }}</small>
      </h3>
		</div>

		<div class="row">
			<div class="w-100">
				<feelings-log
					:key="$route.params.user_id"
					:userid="parseInt($route.params.user_id)"
					:limit="200"
					:readonly="!$route.params.user_id || parseInt($route.params.user_id) === $store.state.profile.id ? 0 : 1"
					:highlight-id="$route.query.reflection ? parseInt($route.query.reflection) : null"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import FeelingsLog from '../components/FeelingsLog.vue';
import BackBtn from "@/components/BackBtn.vue";

export default {
	name: 'Feelings',
	components: {
    BackBtn,
		FeelingsLog,
	},

	data() {
		return {};
	},

	methods: {},

	mounted() {},

	computed: {},
	watch: {},
};
</script>

<style scoped>
.page-header {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 14px;
  position: relative;
}
</style>
